import React, {useEffect, useImperativeHandle, useRef} from 'react';
import PrintHeader from "./print-header.jsx";
import PrintFooter from "./print-footer.jsx";
import "../../../css/style-report.css"
import {useReactToPrint} from "react-to-print";

const PrintTemplate = ({ entity, title, browserTitle, children, printClassName = "", printHeaderClassname = "", setIsPrinting, ref, printFooterClassname = "", landscape = false, customSubTitle = null, onAfterPrint, titleClassName = "" }) => {
    const contentRef = useRef(null);
    const printFinishedRef = useRef(null);

    const finishPrint = () => {
        printFinishedRef.current?.();
        printFinishedRef.current = null;
    }

    const handlePrint = useReactToPrint({
        contentRef,
        documentTitle: browserTitle ?? title,
        onAfterPrint: () => {
            if (setIsPrinting) setIsPrinting(false)
            if (onAfterPrint) onAfterPrint()
            finishPrint();
        },
        onPrintError: (location, error) => {
            console.error(location, error);
            finishPrint();
        }
    });

    // Resolves only after the print dialog closes, so callers can keep print-only content mounted until then.
    const handlePrintWithLoader = async () => {
        if (setIsPrinting) setIsPrinting(true);

        await new Promise(resolve => setTimeout(resolve, 1000));

        if (!contentRef.current) {
            handlePrint();
            return;
        }

        return new Promise(resolve => {
            printFinishedRef.current = resolve;
            handlePrint();
        });
    }

    useImperativeHandle(ref, () => ({print: handlePrintWithLoader}))

    useEffect(() => {
        if (!landscape) return;

        const style = document.createElement("style");

        style.id = "print-landscape-style";
        style.innerHTML = `
        @media print {
            @page {
                size: A3 landscape;
            }
        }
    `;

        document.head.appendChild(style);

        return () => {
            style.remove();
        };
    }, [landscape]);

    return (
        <div className={["print-container print:!px-[25px]", printClassName].join(" ")} ref={contentRef}>
            <table className={"w-full border-collapse"}>
                <thead>
                <tr>
                    <th>
                        <PrintHeader entity={entity} title={title} className={printHeaderClassname} customSubTitle={customSubTitle} titleClassName={titleClassName}/>
                        <div className={"flex justify-center"}>
                            <div className="print-border" />
                        </div>
                    </th>
                </tr>
                </thead>

                <tbody className="report-body">
                <tr>
                    <td>{children}</td>
                </tr>
                </tbody>

                <tfoot className="report-footer">
                <tr>
                    <td id="spacer-footer">
                        <PrintFooter className={printFooterClassname} />
                    </td>
                </tr>
                </tfoot>
            </table>
        </div>
    );
}

export default PrintTemplate;
